import dayjs from 'dayjs'
import { Texts } from '../../../pure-js/libs/Texts'
import { useTeam } from '../hooks/QueryHooks'
import useAppStateSession from '../hooks/useAppStateSession'
import { SectionHeaderAndCTA } from './SectionHeaderAndCTA'

export const DashboardCallEmptyState = () => {
  const { setState } = useAppStateSession()
  const onClick = () => setState((state) => ({ ...state, shouldShowCall: true }))

  const { data: team } = useTeam()

  const wherebyMeeting = team?.metaData?.wherebyMeeting

  const isActve = dayjs(wherebyMeeting?.startDate).isBefore(dayjs()) && dayjs(wherebyMeeting?.endDate).isAfter(dayjs())

  if (!isActve)
    return (
      <SectionHeaderAndCTA
        headerTextKey={Texts.joinTeamCallFirst}
        descriptionTextKey={Texts.teamCallRequirement}
        ctaTextKey={Texts.startTeamCallAndJoin}
        tooltipTextKey={Texts.teamCallTooltip}
        onClick={onClick}
      />
    )

  return (
    <SectionHeaderAndCTA
      headerTextKey={Texts.startTeamVoiceCall}
      descriptionTextKey={Texts.connectWithTeammates}
      ctaTextKey={Texts.startCall}
      tooltipTextKey={Texts.emptyRoomTooltip}
      onClick={onClick}
    />
  )
}
